import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * Shown while a platform admin is impersonating an org member.
 * Clears session storage and returns to platform admin.
 */
export default function ImpersonationBanner() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [active, setActive] = useState(() => {
        try {
            return sessionStorage.getItem('impersonation') === 'true';
        } catch {
            return false;
        }
    });

    const stop = useCallback(() => {
        try {
            sessionStorage.removeItem('impersonation');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('accessToken');
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('uid');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('organizationId');
            sessionStorage.removeItem('orgRole');
            localStorage.removeItem('token');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
        } catch { /* ignore */ }
        setActive(false);
        navigate('/platform/admin/organizations');
        window.location.reload();
    }, [navigate]);

    if (!active) return null;

    return (
        <div
            role="status"
            className="sticky top-0 z-[100000] flex items-center justify-between gap-3 px-4 py-2 text-sm text-start text-amber-950 bg-amber-400 border-b border-amber-500"
        >
            <span className="font-medium min-w-0">
                {t('platformAdmin.impersonation.banner')}
            </span>
            <button
                type="button"
                onClick={stop}
                className="shrink-0 rounded-md bg-amber-950/90 px-3 py-1 text-xs font-semibold text-amber-50 hover:bg-amber-950"
            >
                {t('platformAdmin.impersonation.exit')}
            </button>
        </div>
    );
}
